import $ from 'jquery';

class Navigation {
  constructor() {
    this.nav = $('.js-nav');

    if (!this.nav.length) {
      return;
    }

    this.navDropdowns = this.nav.find('.js-nav-dropdown');
    this.navLinks = this.nav.find('.js-nav-link');
    this.subLinks = this.nav.find('.js-nav-sublink');
    this.navToggler = $('.js-nav-toggler');

    this.debounce = null;
    this.debounceInterval = 500;
    this.breakpoint = 1024;
    this.navType = 'hover';
    this.initialNavType = this.navType;

    this.body = $('body');
    this.header = $('.js-header');
    this.contactBar = this.header.find('.js-header-contact-bar');

    this.bodyPaddingTop = parseFloat(this.body.css('padding-top'));

    this.mobileNavToggler();
    this.dropdownToggles();
    this.headerScroll();

    this.stickyHeader();
    this.navDropdown();

    $(window).on('resize', () => {
      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {
        this.stickyHeader();
        this.navDropdown();
        this.positionMobileNav();
      }, this.debounceInterval);
    });
  }

  stickyHeader() {
    if (this.body.hasClass('has-sticky-header') && this.contactBar.length) {
      this.body.css({
        paddingTop: this.bodyPaddingTop + this.header.outerHeight(),
      });
    }
  }

  scrollDirection() {
    this.newScroll = window.scrollY;

    if (this.newScroll > this.oldScroll) {
      this.scrollDir = 'down';
    } else if (this.newScroll < this.oldScroll) {
      this.scrollDir = 'up';
    }

    this.oldScroll = window.scrollY;
  }

  headerScroll() {
    if (!this.body.hasClass('has-sticky-header')) {
      return;
    }

    if (this.header.length) {
      $(window).on('scroll load', e => {
        const window = $(e.currentTarget);
        this.scrollDirection();

        if (this.scrollDir) {
          if (window.scrollTop() > 100) {
            switch (this.scrollDir) {
              case 'up':
                this.header
                  .removeClass('is-scrolled-down')
                  .addClass('is-scrolled-up');
                break;
              case 'down':
                this.header
                  .removeClass('is-scrolled-up')
                  .addClass('is-scrolled-down');
                break;
              default:
                break;
            }
          } else {
            this.header
              .removeClass('is-scrolled-up')
              .removeClass('is-scrolled-down');
          }
        }

        this.header.toggleClass('is-scrolled', window.scrollTop() > 100);

        if (this.contactBar.length) {
          const adminBar = $('#wpadminbar');
          const adminBarOffset = adminBar.length ? adminBar.outerHeight() : 0;
          const totalOffset =
            $(window).width() >= 1024
              ? -this.contactBar.outerHeight() + adminBarOffset
              : adminBarOffset;

          this.header.css({
            top: this.header.hasClass('is-scrolled') ? totalOffset : '',
          });
        }
      });
    }
  }

  navDropdown() {
    this.nav.each((i, el) => {
      const nav = $(el);
      const navType = nav.data('nav-type') || this.initialNavType;

      if (navType === 'hover') {
        if ($(window).width() > this.breakpoint) {
          this.navType = 'hover';
          this.navDropdownHoverType(nav);
        } else {
          this.navType = 'click';
          this.navDropdownClickType(nav);
        }
      } else {
        this.navType = 'click';
        this.navDropdownClickType(nav);
      }
    });
  }

  navDropdownHoverType(nav) {
    const navLink = nav.find('.js-nav-link');
    const subLinks = nav.find('.js-nav-sublink');

    navLink.add(subLinks).on('click', e => {
      const link = $(e.currentTarget);
      const linkHref = link.attr('href');

      if (linkHref.substr(0, 1) === '#') {
        e.preventDefault();
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.navType === 'hover') {
          window.location = linkHref;
        }
      }
    });

    navLink
      .add(subLinks)
      .on('mouseover focus', e => {
        const link = $(e.currentTarget);

        if (link.hasClass('has-caret') && $(window).width() > this.breakpoint) {
          const dropdown = link.siblings('.js-nav-dropdown');

          if (this.navDropdowns.not(dropdown).length) {
            this.navDropdowns
              .not(dropdown)
              .not(dropdown.parent().closest('.js-main-nav-dropdown'))
              .removeClass('is-open');
          }

          if (this.navLinks.add(subLinks).not(link).length) {
            this.navLinks
              .add(subLinks)
              .not(link)
              .attr('aria-expanded', false);
          }

          if (!dropdown.hasClass('is-open')) {
            dropdown.addClass('is-open');
            link.addClass('has-dropdown-open').attr('aria-expanded', true);
          }
        }
      })
      .on('mouseout blur', e => {
        if ($(window).width() > this.breakpoint) {
          const toElem = e.toElement || e.relatedTarget;
          const toElement = $(toElem);

          this.hideDropdownsOnMouseOut(toElement);
        }
      });

    subLinks.on('mouseout blur', e => {
      if ($(window).width() > this.breakpoint) {
        const toElem = e.toElement || e.relatedTarget;
        const toElement = $(toElem);

        this.hideDropdownsOnMouseOut(toElement);
      }
    });
  }

  navDropdownClickType(nav) {
    const navLink = nav.find('.js-nav-link');
    const subLinks = nav.find('.js-nav-sublink');

    navLink.add(subLinks).off('click');
    navLink.add(subLinks).on('click', e => {
      const link = $(e.currentTarget);

      if (link.hasClass('has-caret')) {
        e.preventDefault();
        const dropdown = link.siblings('.js-nav-dropdown');

        if (this.navDropdowns.not(dropdown).length) {
          this.navDropdowns
            .not(dropdown)
            .not(dropdown.parent().closest('.js-main-nav-dropdown'))
            .removeClass('is-open');
        }

        if (this.navLinks.add(subLinks).not(link).length) {
          this.navLinks
            .add(subLinks)
            .not(link)
            .attr('aria-expanded', false);
        }

        if (dropdown.hasClass('is-open')) {
          dropdown.removeClass('is-open');
          link.removeClass('has-dropdown-open').attr('aria-expanded', false);
        } else {
          dropdown.addClass('is-open');
          link.addClass('has-dropdown-open').attr('aria-expanded', true);
        }
      }
    });

    $(document).on('click', e => {
      const clickedElement = $(e.target);

      if (
        !clickedElement.hasClass('js-nav-link') &&
        !clickedElement.closest('.js-nav-link').length &&
        !clickedElement.closest('.js-nav-item').length &&
        !clickedElement.hasClass('js-nav-sublink') &&
        !clickedElement.closest('.js-nav-sublink').length &&
        !clickedElement.closest('.js-nav-subitem').length
      ) {
        const openDropdown = this.nav.find('.js-nav-dropdown.is-open');

        if (openDropdown.length) {
          openDropdown.removeClass('is-open');
          openDropdown
            .siblings('.js-nav-link')
            .removeClass('has-dropdown-open')
            .attr('aria-expanded', false);
          this.nav
            .find('.js-nav-dropdown-toggle.is-active')
            .removeClass('is-active')
            .attr('aria-expanded', false);
        }
      }
    });
  }

  hideDropdownsOnMouseOut(toElement) {
    if (
      !toElement.hasClass('js-nav-dropdown') &&
      !toElement.closest('.js-nav-dropdown').length
    ) {
      this.navDropdowns.removeClass('is-open');
      this.navLinks
        .attr('aria-expanded', false)
        .removeClass('has-dropdown-open');
    }
  }

  mobileNavToggler() {
    if (this.navToggler.length) {
      this.navToggler.on('click', e => {
        const toggler = $(e.currentTarget);
        const target = toggler.data('target');
        const navigation = toggler.closest('.js-nav');
        const nav = navigation.find(`#${target}`);

        toggler
          .toggleClass('is-active')
          .attr('aria-expanded', toggler.hasClass('is-active'));

        if (nav.length) {
          if (nav.is(':visible')) {
            nav.show();
          }
          nav.toggleClass('is-open');
          this.body.toggleClass('has-mobile-nav-open', nav.hasClass('is-open'));
          this.positionMobileNav();
        }
      });
    }
  }

  // Open the mobile panel right under the header bar, so the logo and the
  // close button stay visible above it. The header height varies with the
  // announcement bar and admin bar, hence measured rather than set in CSS.
  positionMobileNav() {
    const nav = this.nav.find('.c-main-nav.is-open');
    const headerInner = this.header.find('.c-header__inner');

    if (!nav.length || !headerInner.length) {
      return;
    }

    const { bottom } = headerInner[0].getBoundingClientRect();

    nav.css('top', Math.max(0, Math.round(bottom)));
  }

  // Mobile nav: separate caret buttons expand a submenu, leaving the parent
  // item a regular link. Opening one closes its open siblings.
  dropdownToggles() {
    const setOpen = (toggle, isOpen) => {
      toggle.toggleClass('is-active', isOpen).attr('aria-expanded', isOpen);
      $(`#${toggle.attr('aria-controls')}`).toggleClass('is-open', isOpen);
    };

    this.nav.on('click', '.js-nav-dropdown-toggle', e => {
      const toggle = $(e.currentTarget);
      const isOpen = toggle.attr('aria-expanded') !== 'true';

      if (isOpen) {
        toggle
          .parent()
          .siblings()
          .children('.js-nav-dropdown-toggle.is-active')
          .each((i, el) => setOpen($(el), false));
      }

      setOpen(toggle, isOpen);
    });
  }
}

export default new Navigation();



// WEBPACK FOOTER //
// ./src/scripts/modules/navigation.js